export const CATEGORIAS_FOLHA = {
    NORMAL: "Normal",
    VERBAS_INDENIZATORIAS: "Indenizatórias",
    FERIAS: "Férias",
    RESCISAO: "Rescisão",
    DECIMO_TERCEIRO: "Décimo terceiro",
    DECIMO_TERCEIRO_RESCISAO: "Décimo terceiro da rescisão",
    COMPLEMENTAR: "Complementar",
    COMPLEMENTAR_RESCISAO: "Complementar da rescisão",
    COMPLEMENTAR_RRA: "Complementar de rendimentos acumulados",
    SUPLEMENTAR: "Suplementar"
};
export const CATEGORIAS_COMPLEMENTARES = [
    "COMPLEMENTAR",
    "COMPLEMENTAR_RESCISAO",
    "COMPLEMENTAR_RRA"
];
